import Bullet from './behaviors/bullet/Bullet.js';
export default Bullet;